import api from "./api";
import auth from "./auth";

export default {
    getPlanDetails() {
        return new Promise((resolve, reject) => {
            api.get(
                "merchant-service/v1/merchant/cms/plan-details",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    cancelSubscription(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                "merchant-service/merchant/cms/cancel-subscription",
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    savePaymentMethod(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                "payments-service/v1/cms/payment-method/save",
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    removePaymentMethod(payload) {
        return new Promise((resolve, reject) => {
            api.multipleDelete(
                "payments-service/v1/cms/payment-method/remove",
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    makePrimaryPaymentMethod(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                "payments-service/v1/cms/payment-method/primary/save",
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    getBillingHistory({ page, parameters }) {
        return new Promise((resolve, reject) => {
            api.post(
                `payments-service/v1/cms/billing-history/list/${page}`,
                parameters,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    uploadProofOfPayment(payload) {
        return api.post(
            "payments-service/v1/cms/billing/proof-payment/upload",
            payload,
            {
                ...auth.getHeader(),
                "Content-Type": "multipart/form-data"
            }
        );
    },
    getPayoutReceivedSummary() {
        return new Promise((resolve, reject) => {
            api.get(
                "estore-service/v1/cms/disbursements/payout-received",
                auth.getHeader()
            ).then(
                response => resolve(response)
            ).catch(
                (status, errors) => reject(status, errors)
            );
        });
    },
    getPayoutHistory(page) {
        return new Promise((resolve, reject) => {
            api.post(
                `estore-service/v1/cms/disbursements/lists/${page}`,
                null,
                auth.getHeader()
            )
                .then((response) => resolve(response))
                .catch((status, errors) => reject(status, errors));
        });
    },
};
